<template>
    <gc-modal condition="true" @cancel="$emit('cancel')"
              modal-class="gc-modal--wide">

        <template slot="messageTitle">
            Edit software skills
        </template>

        <template slot="body">
            <ul class="member-skills" :class="{ disabled: overLimit }">
                <li v-for="(software, softwareIndex) in softwares" :key="softwareIndex" class="member-skills__item">
                    <a href="#" :class="{ active: software.isActive }"
                       @click.prevent="toggle(software)">
                        {{ software.name }}
                    </a>
                </li>
            </ul>
        </template>

        <template slot="footer">
            <a class="gc-modal__cancel" @click.prevent="$emit('cancel')">Cancel</a>
            <button class="btn btnRed" @click.prevent="save">Save</button>
        </template>
    </gc-modal>
</template>
<script>
    import axios from 'axios'
    export default {
        name: 'SoftwaresModal',
        props: ['modalParams'],
        data () {
            return { softwares: [] };
        },
        created () {
            this.LIMIT = 5;
            let active = {};
            let vm = this;

            Grabcad.store.member.softwares.forEach(function(software) {
                active[software.id] = true;
            });

            Grabcad.store.softwares.forEach(function(software) {
                vm.softwares.push({
                    id: software.id,
                    name: software.name,
                    isActive: active[software.id],
                });
            });
        },
        computed: {
            selected () {
                return this.softwares.filter(function(software) {
                    return software.isActive;
                });
            },
            selectedIds () {
                return this.selected.map(function(elem) {
                    return elem.id;
                });
            },
            overLimit () {
                return this.selected.length >= this.LIMIT;
            }
        },
        methods: {
            toggle (software) {
                if (!software.isActive && this.overLimit) return;
                software.isActive = !software.isActive;
            },
            showUpdated () {
                let message = 'Software skills successfully saved!';
                this.$eventHub.$emit('addAlert', {type: 'success', message: message});
            },
            save () {
                Grabcad.store.member.softwares = this.selected;
                axios.put('/profile', { member: {system_ids: this.selectedIds} });
                this.$emit('cancel');
                this.showUpdated();
            }
        }
    }

</script>